import * as React from 'react';
import { OpenModal } from '../../../../../react-commons/utils/modals/openModal';
import { formatToPascalCase } from '../../../../../react-commons/utils/utilFunctions';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { UpdatedSetting } from '../../../resource/resource-base/settings/types';
import { QueryBaseComponent } from '../../../../../react-commons/query/QueryBaseComponent';
import { BasePropertyAdminSettingsView } from '../../reusable-components/settings/BasePropertyAdminSettingsView';
import {
    useSystemSettingsActions,
} from '../../../resource/resources/persistables/system/settings/systemSettingsResource';

export const SystemSettingsView = () => {
    const systemSettingsActions = useSystemSettingsActions()

    const systemSettingsDefinitionQuery = systemSettingsActions.useGetSettingsMapping();
    const systemSettingsQuery = systemSettingsActions.useGetSingleResource();
    const updateSetting = systemSettingsActions.useUpdateSetting();
    const updateSettingsByCategory = systemSettingsActions.useUpdateSettingsByCategory();

    const onUpdateSetting = (setting: UpdatedSetting) => {
        OpenModal.AlertModal(
            'System Settings Update',
            `Are you sure you want to update system setting ${formatToPascalCase(setting.identifier)}?`,
            () =>
                updateSetting.mutate({
                    id: systemSettingsQuery.data?.id,
                    setting,
                })
        );
    };

    const onUpdateSettingsByCategory = (category: string, settings: UpdatedSetting[]) => {
        OpenModal.AlertModal(
            'Updating System Settings',
            `Are you sure you want to update settings from Category '${category}'?`,
            () =>
                updateSettingsByCategory.mutate({
                    id: systemSettingsQuery.data?.id,
                    category,
                    settings,
                })
        );
    };

    return (
        <QueryBaseComponent name={'System Settings'} query={systemSettingsDefinitionQuery}>
            {(data) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '70%',
                        height: '100%',
                        margin: 'auto',
                        textAlign: 'justify',
                        flexDirection: 'column',
                    }}
                >
                    <BasePropertyAdminSettingsView
                        settingDefinitionMapping={data}
                        onSettingChange={onUpdateSetting}
                        onCategorySettingsChange={onUpdateSettingsByCategory}
                        propertyValidationInformation={{
                            propertyIdentifier: '',
                            resourceType: ResourceType.SYSTEM_SETTINGS,
                            resourceId: systemSettingsQuery.data?.id,
                        }}
                    />
                </div>
            )}
        </QueryBaseComponent>
    );
};


